module.exports = __webpack_public_path__ + "img/hc_pro_eight_1.892cf2f1.jpg";